@if (loading && !errorMessage) {
    <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center">
        <kui-loader> </kui-loader>
    </div>
}

<kui-accordion class="flex-1">
    @for (group of sectionGroups; track group) {
        <div class="section-group" [class.active]="activeCard === group.name">
            <kui-card-header [active]="activeCard === group.name" (click)="onCardClick(group.name)">
                <kui-card-title>
                    {{ group.name }}
                </kui-card-title>
                <ul class="content-card-actions">
                    <!-- ACTIONS -->
                    @if (activeCard === group.name) {
                        <ng-container>
                            @for (action of group.actions; track action) {
                                <li class="mr-1">
                                    @if (action.menu || action.template) {
                                        <ng-container>
                                            <kui-dropdown [style]="'none'" [menu]="action.menu" [customContent]="action.template" [customContentContext]="action.templateContext">
                                                <kui-icon kui-action size="sm" [name]="action.icon" [class.active]="action.active" [title]="action.name"></kui-icon>
                                            </kui-dropdown>
                                        </ng-container>
                                    } @else {
                                        <kui-icon kui-action size="sm" [class.active]="action.active" [name]="action.icon" [title]="action.name" (click)="action.click()">
                                        </kui-icon>
                                    }
                                </li>
                            }
                        </ng-container>
                    }

                    <li>
                        <kui-icon name="collapse"></kui-icon>
                    </li>
                </ul>
            </kui-card-header>
            <kui-card-body>
                <kui-card-text class="d-flex flex-column w-100">
                    @for (section of group.sections; track section) {
                        <div class="section w-100 flex-column" [class.d-flex]="section.type === 'list'" [class.flex-1]="section.type === 'list'">
                            @if ((entity || section.bulk) && !section.hidden) {
                                <div [class.disabled]="editing && section !== editing" class="flex-1 d-flex w-100 flex-column">
                                    @switch (section.type) {
                                        @case ("form") {
                                            <key-admin-form-editor
                                                [editable]="!editing"
                                                [entity]="entity"
                                                [handler]="section"
                                                (onEditing)="onEntityEditing(section, $event)"
                                                (onSaving)="onEntitySaving()"
                                                (onSaved)="onEntitySaved($event)"
                                            ></key-admin-form-editor>
                                        }
                                        @case ("contacts") {
                                            <key-admin-contact-editor
                                                [editable]="!editing"
                                                [entity]="entity"
                                                [handler]="section"
                                                (onEditing)="onEntityEditing(section, $event)"
                                                (onSaving)="onEntitySaving()"
                                                (onSaved)="onEntitySaved($event)"
                                            ></key-admin-contact-editor>
                                        }
                                        @case ("list") {
                                            <key-admin-list-editor
                                                class="d-flex flex-1 flex-column w-100"
                                                [editable]="!editing"
                                                [entity]="entity"
                                                [handler]="section"
                                                (onEditing)="onEntityEditing(section, $event)"
                                                (onSaving)="onEntitySaving()"
                                                (onSaved)="onEntitySaved($event)"
                                            ></key-admin-list-editor>
                                        }
                                        @case ("inline-list") {
                                            <key-admin-inline-list-editor
                                                [editable]="!editing"
                                                [entity]="entity"
                                                [handler]="section"
                                                (onEditing)="onEntityEditing(section, $event)"
                                                (onSaving)="onEntitySaving()"
                                                (onSaved)="onEntitySaved($event)"
                                            ></key-admin-inline-list-editor>
                                        }
                                        @case ("zone") {
                                            <key-admin-zone-editor
                                                class="d-flex flex-1 flex-column w-100"
                                                [editable]="!editing"
                                                [entity]="entity"
                                                [handler]="section"
                                                (onEditing)="onEntityEditing(section, $event)"
                                                (onSaving)="onEntitySaving()"
                                                (onSaved)="onEntitySaved($event)"
                                            ></key-admin-zone-editor>
                                        }
                                        @case ("chart") {
                                            <key-admin-chart
                                                class="d-flex flex-1 flex-column w-100"
                                                [entity]="entity"
                                                [handler]="section"
                                                [visible]="activeCard === group.name"
                                            ></key-admin-chart>
                                        }
                                        @case ("media") {
                                            <key-admin-media
                                                class="d-flex flex-1 flex-column w-100"
                                                [entity]="entity"
                                                [handler]="section"
                                                [visible]="activeCard === group.name"
                                            ></key-admin-media>
                                        }
                                        @case ("custom") {
                                            <key-admin-custom
                                                class="d-flex flex-1 flex-column w-100"
                                                [entity]="entity"
                                                [handler]="section"
                                                [visible]="activeCard === group.name"
                                            ></key-admin-custom>
                                        }
                                        @case ("feed") {
                                            <key-admin-feed
                                                class="d-flex flex-1 flex-column w-100"
                                                [entity]="entity"
                                                [handler]="section"
                                                [visible]="activeCard === group.name"
                                            ></key-admin-feed>
                                        }
                                        @default {
                                            No editor found for type "{{ section.type }}"
                                        }
                                    }
                                </div>
                            }
                        </div>
                    }

                    @if (group.warnings) {
                        <div>
                            @for (warning of group.warnings; track warning) {
                                <div class="p-4 d-flex flex-stretch border-bottom">
                                    <kui-icon name="warning" color="danger" class="px-2 pt-1" size="lg"></kui-icon>
                                    <span class="pl-3" [innerHTML]="warning"></span>
                                </div>
                            }
                        </div>
                    }

                    @if (group.message) {
                        <div class="p-4 h-100 d-flex flex-stretch justify-content-center align-items-center">
                            <kui-icon name="warning" class="px-3" size="lg"></kui-icon>
                            <span>{{ group.message }}</span>
                        </div>
                    }
                </kui-card-text>
            </kui-card-body>
        </div>
    }

    @for (panel of customPanels; track panel) {
        <div class="section-group" [class.active]="activeCard === panel.title">
            <kui-card-header [active]="activeCard === panel.title" (click)="onCardClick(panel.title)">
                <kui-card-title>
                    {{ panel.title }}
                </kui-card-title>
                <ul class="content-card-actions">
                    <li>
                        <kui-icon name="collapse"></kui-icon>
                    </li>
                </ul>
            </kui-card-header>
            <kui-card-body>
                <kui-card-text class="section">
                    <div class="section h-100">
                        @if (panel.activated) {
                            <iframe width="100%" height="100%" frameBorder="0" [src]="panel.url"> </iframe>
                        }
                    </div>
                </kui-card-text>
            </kui-card-body>
        </div>
    }

    @if (changesVisible) {
        <div class="section-group" [class.active]="activeCard === changesTitle">
            <kui-card-header [active]="activeCard === changesTitle" (click)="onCardClick(changesTitle)">
                <kui-card-title>
                    {{ changesTitle }}
                </kui-card-title>
                <ul class="content-card-actions">
                    <li>
                        <kui-icon name="collapse"></kui-icon>
                    </li>
                </ul>
            </kui-card-header>
            <kui-card-body>
                <kui-card-text class="section">
                    <div class="section h-100">
                        @if (entity && activeCard === changesTitle) {
                            <key-feed type="audit" originType="asset" [clientId]="company" [id]="auditId" [showDetailsModal]="true" primaryAction="detailsModal"></key-feed>
                        }
                    </div>
                </kui-card-text>
            </kui-card-body>
        </div>
    }
</kui-accordion>

<kui-alert-panel [message]="errorMessage"></kui-alert-panel>
